<template>
    <Modal
        maxWidth="425px"
        minWidth="300px"
        maxHeight="fit-content"
        :isOpen="isOpen"
        v-on:toggleModal="$emit('toggleModal')"
        v-if="isOpen"
    >
        <template v-slot:title>
            <p class="modal-card-title">Which course are you rating?</p>
        </template>
        <template v-slot:body>
            <div class="course-container">
                <div
                    class="modal-course"
                    v-for="(course, index) in courses"
                    :key="'modal-course-' + index"
                    @click="setCurrentCourse(course.id)"
                    v-bind:class="{ active: currentCourse === course.id }"
                >
                    {{ course.code }}
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/modals/Modal";
import { firestore } from "@/firebase.js";

export default {
    name: "RatingSelectionModal",

    components: {
        Modal,
    },

    props: {
        isOpen: Boolean,
    },

    data() {
        return {
            courses: [],
            currentCourse: "",
        };
    },

    computed: {
        routeTo() {
            if (this.currentCourse === "") {
                return "/";
            } else {
                return "/rate/" + this.currentCourse;
            }
        },
    },

    methods: {
        setCurrentCourse(course) {
            this.currentCourse = course;
            this.$emit("toggleModal");
            this.$router.push(this.routeTo);
            location.reload();
        },
    },

    // Connect our datato our firestore collections and documents
    firestore: {
        courses: firestore
            .collection("university")
            .doc("uw")
            .collection("courses")
            .where("visible", "==", true),
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

.course-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    width: 100%;
    justify-items: center;
}

.modal-course {
    color: #999999;
    padding: 10px 20px;
    font-size: 16px;
    border: 1px solid #999999;
    border-radius: 12px;
    text-align: center;

    &:hover {
        cursor: pointer;
        background-color: #e3c855;
        border: 1px solid #e3c855;
        color: white;
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    .modal-course {
        font-size: 14px;
    }
}
</style>
